import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background text-center text-foreground" aria-label="Limited time offer" data-id="element-237" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-electric shadow-[0_0_16px_rgba(0,207,255,0.7)]" aria-hidden="true" data-id="element-238" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-239" data-mp="31hxxwh0jq1rc">
        <p className="inline-flex items-center gap-2 font-display text-base font-bold uppercase tracking-[.16em] text-electric" data-id="element-240" data-mp="3g7ly1ewzqudh">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="3b895qencov3i" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-242" data-mp="3p8a4nok21sgc" />
        <p className="mt-7 font-bold text-foreground" data-id="element-243" data-mp="3l78ctssgwioe">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-electric shadow-[0_0_16px_rgba(0,207,255,0.7)]" aria-hidden="true" data-id="element-244" data-mp="1uu9674sf37gs" />
    </section>;
}